import { v4 as uuid } from "uuid";
import { toJSON } from "../utils";
import { normalizeAddress } from "./nft";
export var ContractError;
(function (ContractError) {
    ContractError["MISSING_PROVIDER"] = "missing_provider";
    ContractError["UNKNOWN_METHOD"] = "unknown_method";
    ContractError["UNKNOWN_CONTRACT"] = "unknown_contract";
    ContractError["UNAUTHORIZED"] = "unauthorized";
    ContractError["UNSUPPORTED_NETWORK"] = "unsupported_network";
    ContractError["EXECUTION_ERROR"] = "execution_error";
    ContractError["EXECUTION_TIMEOUT"] = "execution_timeout";
})(ContractError || (ContractError = {}));
export class SmartContract {
    constructor(params) {
        this.id = params.id || uuid();
        this.name = params.name;
        this.abi = params.abi;
        this.network = params.network;
        this.address = normalizeAddress(this.network, params.address);
        this.owner = normalizeAddress(this.network, params.owner);
        this.standard = params.standard;
        this.methods = params.methods || [];
        this.createdAt = Number(params.createdAt || new Date().valueOf());
        this.updatedAt = Number(params.updatedAt || new Date().valueOf());
    }
    get json() {
        return toJSON(this);
    }
}
